import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "@chakra-ui/react";
import { H2, BodyText } from "src/atoms/typography";
import { Lottie } from "src/components/Lottie";
import { SceneLayout } from "src/components/SceneLayout";
import NavigationButtons from "src/components/NavigationButtons";
import usePrevious from "src/hooks/usePrevious";

export default function WaitingForResponse({
  response,
  onReceivedResponse,
  deviceName,
  mode,
  onBack,
  onClose,
  request
}) {
  const { t } = useTranslation();
  const prevResponse = usePrevious(response);

  useEffect(() => {
    if (prevResponse !== response && response !== null) {
      onReceivedResponse();
    }
  }, [onReceivedResponse, prevResponse, response]);

  return (
    <>
      <NavigationButtons
        mode={mode}
        backButtonProps={{ onClick: onBack, disabled: request == null }}
        closeButtonProps={{ onClick: onClose, disabled: request == null }}
      />
      <SceneLayout
        centerProps={{ width: "320px" }}
        center={
          <>
            <Lottie width="176px" height="128px" animationName="pair.json" />
            <H2 color="highEmphasis" mt="24px" textAlign="center">
              {t("pairing.requester.waiting.heading")}
            </H2>
            <BodyText
              color="mediumEmphasis"
              mt="8px"
              mb="32px"
              textAlign="center"
            >
              {t("pairing.requester.waiting.text", { value0: deviceName })}
            </BodyText>
            <Spinner />
          </>
        }
      />
    </>
  );
}
